import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import styles from './index.module.css';
import NotFound from "../components/NotFound";
import Footer from "../components/Footers";
import ExamControllerAssistantSidebar from "../components/Sidebar/ExamControllerAssistantSidebar";
import ExamControllerAssistantRoutes from "../routes/ExamControllerAssistantRoutes";
import EntityAdminHeader from "../components/Header/EntityAdminHeader";

const ExamControllerAssistantLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div className={styles.appContainer}>
            <ExamControllerAssistantSidebar  isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar}/>
            <div className={styles.main}>                
            <EntityAdminHeader toggleSidebar={toggleSidebar}/>
            <div className={styles.content}>
                <Routes>
                    {ExamControllerAssistantRoutes.map((prop, key) => (
                        <Route path={prop.path} element={prop.element} key={key} />
                    ))}
                    <Route path="*" element={<div><NotFound/></div>} />
                </Routes>
                <Footer/>        
            </div>    
            </div>
        </div>
    );
};

export default ExamControllerAssistantLayout;
